import { Button, Space, Typography } from "antd";
import ComponentePermissao from "../../../../Base/Permissao/ComponentePermissao";
import { useNavigate } from "react-router-dom";
import MovimentacaoDesativarPopconfirm from "./MovimentacaoDesativarPopconfirm";
import Utilitario from "../../../../../Utils/Utilitario";
import TablePaginadaBasic, { ITablePaginadaBasicProps } from "@/Components/Base/Table/TablePaginadaBasic";
import { _MovimentacaoSemRecursao, Movimentacao } from "@/Models/Financeiro/Conta/Movimentacao";

export interface IMovimentacaoTableBasicProps extends ITablePaginadaBasicProps<Movimentacao, _MovimentacaoSemRecursao> {
    pathBaseLink?:string;
    onSuccess?:() => void;
}
export default function MovimentacaoTableBasic({
    pathBaseLink,
    onSuccess,
    ...rest
}: IMovimentacaoTableBasicProps) {
    const navigate = useNavigate();

    pathBaseLink = pathBaseLink === undefined ? '' : pathBaseLink;

    return <TablePaginadaBasic<Movimentacao, _MovimentacaoSemRecursao>
        {...rest}
        rowKey={(m) => m.codigo!.toString()}
        // addTitleOn="xxl"
        disableResponsiveness={true}
        tableLayout="auto"
        scroll={{
            x: true,
        }}
        minColWidthIfResponsivenessDisabled={"120px"}
        showHeader={true}
        columns={[
            {
                key : "codigo",
                title : "#",
                dataIndex : ["codigo"],
                render: (value: number, record) => (record.codMovimentacaoBase ?? 0) <= 0 ? value : record.codMovimentacaoBase,
                // breakpoints : { xs : 12, sm : 12, md : 8, lg : 8, xl : 6, xxl : 2 }
                minWidth : "70px"
            },
            {
                key : "entrada",
                title : "Mov.",
                dataIndex : ["entrada"],
                render: (value: boolean) => value ? "Entrada" : "Saída",
                // breakpoints : { xs : 12, sm : 12, md : 8, lg : 8, xl : 6, xxl : 2 }
                minWidth : "70px"
            },
            {
                key : "data",
                title : "Data",
                dataIndex : ["dataMovimentacao"],
                render: (value) => value?.toLocaleString().replace(',', '').substring(0, 16),
                breakpoints : { xs : 24, sm : 12, md : 8, lg : 8, xl : 6, xxl : 3 }
            },
            {
                key : "forma",
                title : "Forma",
                dataIndex : ["movFormaPagamento", "nome"],
                breakpoints : { xs : 24, sm : 12, md : 8, lg : 8, xl : 6, xxl : 5 },
                render(value, record, index) {
                    return value ?? " - ";
                },
            },
            {
                key : "conta",
                title : "Conta",
                dataIndex : ["conta", "nome"],
                breakpoints : { xs : 24, sm : 12, md : 8, lg : 8, xl : 6, xxl : 5 }
            },
            {
                key : "valorTransacao",
                title : "Valor",
                dataIndex : ["valorTransacao"],
                breakpoints : { xs : 24, sm : 12, md : 8, lg : 8, xl : 6, xxl : 3 },
                render(value, record, index) {
                    return <Typography.Text type={record.entrada ? "success" : "danger"}>{Utilitario.toStringDinheiro(value * (record.entrada ? 1 : -1))}</Typography.Text>;
                }
            },
            {
                key : "acoes",
                title : "Ações",
                dataIndex : ["codigo"],
                breakpoints : { xs : 24, sm : 24, md : 24, lg : 24, xl : 12, xxl : 4 },
                render(value, record, index) {
                    return <OpcoesMovimentacao 
                        value={value}
                        record={record}
                        pathBaseLink={pathBaseLink}
                        onSuccess={onSuccess}
                    />
                    // return <ComponentePermissao tipo="any" permissoes={["FinanceiroContaMovimentacaoAlterar", "FinanceiroContaMovimentacaoDesativar", "FinanceiroContaMovimentacaoListarPorIdentificador"]}>
                    //     <Space size="small" wrap>
                    //         <ComponentePermissao permissoes={["FinanceiroContaMovimentacaoListarPorIdentificador"]}>
                    //             <Button
                    //                 type='dashed'
                    //                 size='small'
                    //                 style={{ width: "min-content" }}
                    //                 onClick={(ev) => navigate(`${pathBaseLink}Visualizar/${(record.codMovimentacaoBase ?? 0) <= 0 ? value : record.codMovimentacaoBase}`)}
                    //             >
                    //                 Ver
                    //             </Button>
                    //         </ComponentePermissao>
                    //         <ComponentePermissao permissoes={["FinanceiroContaMovimentacaoAlterar", "FinanceiroContaMovimentacaoListarPorIdentificador"]}>
                    //             <Button
                    //                 type='primary'
                    //                 size='small'
                    //                 style={{ width: "min-content" }}
                    //                 onClick={(ev) => navigate(`${pathBaseLink}Editar/${(record.codMovimentacaoBase ?? 0) <= 0 ? value : record.codMovimentacaoBase}`)}
                    //             >
                    //                 Editar
                    //             </Button>
                    //         </ComponentePermissao>
                    //         <ComponentePermissao permissoes={["FinanceiroContaMovimentacaoDesativar"]}>
                    //             <MovimentacaoDesativarPopconfirm 
                    //                 movimentacao={(record.codMovimentacaoBase ?? 0) <= 0 ? record : record.movimentacaoBase!}
                    //             />
                    //         </ComponentePermissao>
                    //     </Space>
                    // </ComponentePermissao>;
                },
            }
        ]}
    />
}

export function OpcoesMovimentacao({ value, record, pathBaseLink, onSuccess }:{pathBaseLink?:string, value:number, record:Movimentacao, onSuccess : () => void }) {
    pathBaseLink = pathBaseLink === undefined ? '' : pathBaseLink;
    const navigate = useNavigate();
    
    return <ComponentePermissao tipo="any" permissoes={["FinanceiroContaMovimentacaoAlterar", "FinanceiroContaMovimentacaoDesativar", "FinanceiroContaMovimentacaoListarPorIdentificador"]}>
        <Space size="small" wrap>
            <ComponentePermissao permissoes={["FinanceiroContaMovimentacaoListarPorIdentificador"]}>
                <Button
                    type='dashed'
                    size='small'
                    style={{ width: "min-content" }}
                    onClick={(ev) => navigate(`${pathBaseLink}Visualizar/${(record.codMovimentacaoBase ?? 0) <= 0 ? value : record.codMovimentacaoBase}`)}
                >
                    Ver
                </Button>
            </ComponentePermissao>
            <ComponentePermissao permissoes={["FinanceiroContaMovimentacaoAlterar", "FinanceiroContaMovimentacaoListarPorIdentificador"]}>
                <Button
                    type='primary'
                    size='small'
                    style={{ width: "min-content" }}
                    onClick={(ev) => navigate(`${pathBaseLink}Editar/${(record.codMovimentacaoBase ?? 0) <= 0 ? value : record.codMovimentacaoBase}`)}
                >
                    Editar
                </Button>
            </ComponentePermissao>
            <ComponentePermissao permissoes={["FinanceiroContaMovimentacaoDesativar"]}>
                <MovimentacaoDesativarPopconfirm 
                    movimentacao={(record.codMovimentacaoBase ?? 0) <= 0 ? record : record.movimentacaoBase!}
                    onSuccess={onSuccess}
                />
            </ComponentePermissao>
        </Space>
    </ComponentePermissao>;
}